/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isArray } from 'lodash';

// Components
import WizardStep from 'shared/ui/components/WizardStep.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

/**
 * This component will contain the summary of the information gathered in the previous steps.
 *
 * If the user has chosen a template that includes modules that are paid for the chosen organization,
 * an expandable banner will be shown to notify the user
 *
 * When the user expands the banner, a list of all the paid modules that will be installed
 *
 * Clicking on “edit” sends the user back to the the step where that field is found and focuses
 * the field to edit if possible (Dropdowns, text fields, …)
 *
 * @category ui.components.wizards.create-workspace
 * @exports WorkspaceSummary
 * @component
 */
const __vue_script__ = {
    name: 'WorkspaceSummary',

    components: { ExpandableContent },

    extends: WizardStep,

    data() {

        return {
            categoryLabel: '',
            displayAnonymization: false,
            forcedAnonymization: false,
            eventType: '',
            template: {
                description: {},
                packages: []
            }
        };
    },

    async created() {
        // Template's details are loaded in `Templates.vue` with only paid modules
        this.template = this.form.template;

        let { category_label } = get(this.form, 'organization.workspace_defaults', {});
        if (!category_label) {
            if (isArray(this.form.categories)) {
                category_label = 'wizards.create_workspace.summary.fields.categories';
            } else {
                category_label = 'wizards.create_workspace.summary.fields.category';
            }
        }
        this.categoryLabel = this.$i18n.te(category_label) ? this.$i18n.t(category_label) : category_label;

        this.displayAnonymization = this.form.organization.enable_anonymization;
        this.forcedAnonymization = this.form.organization.workspace_defaults?.force_anonymization;

        try {
            const options = await this.$services.org.getCreationOptions(this.form.organization.name, this.form.audience_type);
            this.eventType = options.find(o => o.value === this.form.event_classification).label;
        } catch (error) {
            console.error('[WorkspaceSummary] Could not load event type label', error);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace-summary"},[(_vm.template.packages.length)?_c('div',{staticClass:"alert alert-warning"},[_c('expandable-content',{attrs:{"clickable-header":true}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.alerts.paid_modules")))])])]),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.alerts.module_install")))])]),_c('ul',_vm._l((_vm.template.packages),function(mod){return _c('li',[_vm._v(_vm._s(mod.title || mod.name))])}),0)])],1):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.summary.intro')))]),_c('h3',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.summary.title')))]),_c('table',[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.organization")))]),_c('td',{attrs:{"data-testing":"form.organization.name"},domProps:{"innerHTML":_vm._s(_vm.form.organization.display_name)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(1, 'organization')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.template")))]),_c('td',{attrs:{"data-testing":"form.template.name"}},[_vm._v(_vm._s(_vm.getWorkspaceName(_vm.template)))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(1)}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.name")))]),_c('td',{attrs:{"data-testing":"form.name"},domProps:{"innerHTML":_vm._s(_vm.form.name)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'name')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.start_date")))]),_c('td',{attrs:{"data-testing":"form.start_date"}},[_vm._v(_vm._s(_vm.$utils.time.toLongDateTimeFormat(_vm.form.start_date)))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'start_date')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.end_date")))]),_c('td',{attrs:{"data-testing":"form.end_date"}},[_vm._v(_vm._s(_vm.$utils.time.toLongDateTimeFormat(_vm.form.end_date)))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'end_date')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),(_vm.form.event_format)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.event_format')))]),_c('td',{attrs:{"data-testing":"form.event_format"}},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.form.event_formats." + (_vm.form.event_format)))))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'event_format')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.audience_type)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.audience_type')))]),_c('td',{attrs:{"data-testing":"form.audience_type"}},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.form.audience_types." + (_vm.form.audience_type)))))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'audience_type')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.event_scope)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.event_scope')))]),_c('td',{attrs:{"data-testing":"form.event_scope"}},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.form.event_scopes." + (_vm.form.event_scope)))))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'event_scope')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.expected_attendance)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.expected_attendance')))]),_c('td',{attrs:{"data-testing":"form.expected_attendance"}},[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.form.expected_attendances." + (_vm.form.expected_attendance)))))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'expected_attendance')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.event_classification)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.event_classification')))]),_c('td',{attrs:{"data-testing":"form.event_classification"}},[_vm._v(_vm._s(_vm.eventType)),(_vm.form.event_custom_classification)?_c('span',[_vm._v(" - "+_vm._s(_vm.form.event_custom_classification))]):_vm._e()]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(3, this.form.event_classification === 'other' ? 'event_custom_classification' : 'event_classification')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.category)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.categoryLabel))]),_c('td',{attrs:{"data-testing":"form.category"}},[_vm._v(_vm._s(_vm.form.category))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'category')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),(_vm.form.categories && _vm.form.categories.length)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.categoryLabel))]),_c('td',{attrs:{"data-testing":"form.categories"}},[_vm._v(_vm._s(_vm.form.categories.join(', ')))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'categories')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.privacy_documents")))]),_c('td',{attrs:{"data-testing":"form.privacy_documents"}},[(_vm.form.privacy_documents.length > 1)?_c('ul',_vm._l((_vm.form.privacy_documents),function(doc){return _c('li',{domProps:{"innerHTML":_vm._s(doc.title)}})}),0):_vm._e(),(_vm.form.privacy_documents.length === 1)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.form.privacy_documents[0].title)}}):_vm._e()]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'privacy_documents')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),(_vm.form.container_app.springboard_name)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.container_app")))]),_c('td',{attrs:{"data-testing":"form.container_app.springboard_name"},domProps:{"innerHTML":_vm._s(_vm.form.container_app.springboard_name)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'container_app')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]):_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.test_workspace")))]),_c('td',{attrs:{"data-testing":"form.test_workspace"}},[_vm._v(_vm._s(_vm.$t(("base." + (_vm.form.test_workspace ? 'yes' : 'no')))))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'test_workspace')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),(_vm.displayAnonymization)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.form.fieldsets.anonymization")))]),_c('td',[_vm._v(_vm._s(_vm.$t(("wizards.create_workspace.form." + (_vm.form.anonymization ? '' : 'not_') + "anonymized"))))]),(!_vm.forcedAnonymization)?_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(2, 'anonymization')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])]):_vm._e()]):_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.users")))]),_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.alerts.users_limit"))),_c('br'),_c('span',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.alerts.users_hint")))])])])])]),_c('h3',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.venue')))]),_c('table',[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.country")))]),_c('td',{attrs:{"data-testing":"form.country"}},[_vm._v(_vm._s(_vm.form.country.join(', ')))]),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(4, 'country')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.city")))]),_c('td',{attrs:{"data-testing":"form.city"},domProps:{"innerHTML":_vm._s(_vm.form.city)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(4, 'city')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.timezone")))]),_c('td',{attrs:{"data-testing":"form.timezone"},domProps:{"innerHTML":_vm._s(_vm.form.timezone)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(4, 'timezone')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.fields.servers_location")))]),_c('td',{attrs:{"data-testing":"form.servers_location.label"},domProps:{"innerHTML":_vm._s(_vm.form.servers_location.label)}}),_c('td',{staticClass:"actions"},[_c('a',{staticClass:"has-action",on:{"click":function($event){return _vm.toStep(4, 'servers_location')}}},[_vm._v(_vm._s(_vm.$t("wizards.create_workspace.summary.edit")))])])])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WorkspaceSummary.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__